import React, { ReactNode } from 'react';
import { useAsyncState } from 'utils/hooks';
import { useParams } from 'react-router';
import { getProfileDetails } from 'services/profiles';
import { LinkTab, LoadingIndicator, Tabs } from '@ygtechnologies/bygr-frontend-component-library';
import { BygrProfileDetails } from 'types';
import ProfileMembers from './ProfileMembers';
import ProfileInvites from './ProfileInvites';
import ProfileDashboard from './ProfileDashboard';
import ProfileProjects from './ProfileProjects';
import ProfileLicenses from './ProfileLicenses';
import { ProfileFeatures } from './ProfileFeatures';
import { ProfileContractorProjects } from './ProfileContractorProjects';
// import theme from './ProjectDetails.module.scss';

interface ProfilesDetailsProps {
    // projectId: number;
}

export type ProfileDetailsTab =
    | 'dashboard'
    | 'members'
    | 'invites'
    | 'projects'
    | 'licenses'
    | 'features'
    | 'contractor-projects';

interface TabSettings {
    id: ProfileDetailsTab;
    name: string;
    render(opts: { profile: BygrProfileDetails; reloadProfile(): void }): ReactNode;
}

const tabs: TabSettings[] = [
    {
        id: 'dashboard',
        name: 'Dashboard',
        render: (props) => <ProfileDashboard {...props} />,
    },
    {
        id: 'members',
        name: 'Members',
        render: (props) => <ProfileMembers {...props} />,
    },

    {
        id: 'invites',
        name: 'Profile invites',
        render: (props) => <ProfileInvites {...props} />,
    },
    {
        id: 'projects',
        name: 'Projects',
        render: (props) => <ProfileProjects {...props} />,
    },
    {
        id: 'contractor-projects',
        name: 'Contractor projects',
        render: (props) => <ProfileContractorProjects {...props} />,
    },
    {
        id: 'licenses',
        name: 'Licenses',
        render: (props) => <ProfileLicenses {...props} />,
    },
    {
        id: 'features',
        name: 'Features',
        render: (props) => <ProfileFeatures {...props} />,
    },
];

const ProfileDetails: React.FC<ProfilesDetailsProps> = () => {
    const { profileId, tab } = useParams<{ profileId: string; tab: ProfileDetailsTab }>();
    const [profile, , reloadProfile] = useAsyncState(() => getProfileDetails(+profileId), [profileId], null);

    if (!profile) {
        return <LoadingIndicator />;
    }

    return (
        <>
            <h3>Profile {profile.name}</h3>
            <Tabs activeTabId={tab}>
                {tabs.map((tab) => (
                    <LinkTab key={tab.id} id={tab.id} name={tab.name} to={`/profiles/${profileId}/${tab.id}`}>
                        <div>{tab.render({ profile, reloadProfile })}</div>
                    </LinkTab>
                ))}
            </Tabs>
        </>
    );
};

export default ProfileDetails;
